<template>
	<div class="activity-event-body">
		<ProfilePic v-if="user" :user="user" size="36px" class="event-avatar" />
		<div v-else class="event-avatar event-avatar-fallback">
			<CircleExclamationIcon type="regular" />
		</div>
		<div class="event-content">
			<div v-if="user" class="event-author" v-text="user.fullname" />
			<div class="event-text" v-text="eventText" />
		</div>
	</div>
</template>

<script>
import { ProfilePic } from '@/components/common'
import { CircleExclamationIcon } from '@/icons'

export default {
	name: 'ActivityEventBody',

	components: { ProfilePic, CircleExclamationIcon },

	props: {
		item: { type: Object, required: true },
	},

	computed: {
		user() {
			return this.item.message?.user || null
		},

		eventText() {
			return (this.item.message?.text || '').trim()
		},
	},
}
</script>

<style lang="scss" scoped>
.activity-event-body {
	display: flex;
	gap: 19px;
	align-items: flex-start;
}

.event-avatar {
	flex-shrink: 0;
}

.event-avatar-fallback {
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background: var(--interaction-event-bg);
	color: var(--interaction-event-accent);
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
}

.event-content {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 5px;
}

.event-author {
	font-family: Avenir-Heavy;
	font-size: 15px;
	color: var(--neutral-800);
}

.event-text {
	font-family: Avenir-MediumOblique, Avenir-Medium, sans-serif;
	font-style: italic;
	font-size: 17px;
	line-height: 16px;
	color: var(--neutral-300);
}
</style>
